<div class="example-preview-item">
    <div class="clipping-container">
        <div class="example-avatar blue">
            <app-svg-task-selector [name]=serviceTask.strTaskType().en></app-svg-task-selector>
        </div>
        <div class="example-item-text">
            <div class="example-item-title bold">{{serviceTask.title}}</div>
            <div class="example-item-description">{{serviceTask.description}}</div>
        </div>
    </div>
</div>